export function formatImageThumbnail(image: string | null) {
  if (!image) return "";

  return (
    process.env.NEXT_PUBLIC_STORAGE_URL +
    image?.replace(/(\.[^/.]+)$/, "-250$1")
  );
}
